import { render, staticRenderFns } from "./QuestionFileDetail.vue?vue&type=template&id=4df124a6"
import script from "./QuestionFileDetail.vue?vue&type=script&lang=ts"
export * from "./QuestionFileDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports